/* global axios */
import ApiClient from './ApiClient';

class CampaignsReportsAPI extends ApiClient {
  constructor() {
    super('campaign_reports', { accountScoped: true });
  }

  getMetrics(params = {}) {
    return axios.get(`${this.url}/metrics`, { params });
  }
}

export default new CampaignsReportsAPI();
